import script from "./ContactList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactList.vue?vue&type=script&setup=true&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=70788348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70788348"]])

export default __exports__